module.exports = __webpack_public_path__ + "media/src/images/logo-b2d9ebb18db54a418799959d1dbe91b7.svg";